import React, {Component} from 'react';

// import saveAs from 'file-saver';
// import VCard from 'vcard-creator';

export default class CranstenTest extends Component {

    async componentDidMount() {
    }

    async componentDidUpdate(){
    }

    state = {
        text: ''
    }

    // saveContact = () =>{
    //     const myVCard = new VCard()
    //
    //     var lastname = 'Desloovere'
    //     var firstname = 'Jeroen'
    //
    //     myVCard.addName(lastname, firstname)
    //     // myVCard.addCompany('Siesqo')
    //     // myVCard.addJobtitle('Web Developer')
    //     // myVCard.addRole('Data Protection Officer')
    //     myVCard.addEmail('info@jeroendesloovere.be')
    //     // myVCard.addPhoneNumber(1234121212, 'PREF;WORK')
    //     myVCard.addPhoneNumber(123456789, 'WORK')
    //     // myVCard.addAddress(null, null, 'street', 'worktown', null, 'workpostcode', 'Belgium')
    //     // myVCard.addURL('http://www.jeroendesloovere.be')
    //
    //     const blob = new Blob([ myVCard.toString() ], { type: "text/vcard;charset=utf-8" });
    //     saveAs(blob, "New_Contact.vcf");
    //
    //     // console.log(myVCard.toString())
    //     this.setState({text: myVCard.toString()})
    // }

    render() {
        return (
            <div>
                <h1>Save Contact</h1>
                {/*<button onClick={()=>this.saveContact()}>Snimi nesto</button>*/}
                <h3>{this.state.text}</h3>
            </div>
        );
    }
}
